import React from 'react';
import {Box, Sheet, Stack} from '@mui/joy';
import NavBar from "./NavBar";
import {MyDrawer} from "./Drawer";
import {DrawerContext} from '../context/DrawerContext';
import {SummaryModel} from "../model/summary";

function AppBar({onChangeTheme, summary} : {onChangeTheme:any,summary:SummaryModel}) {
    const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);

    function handlerDrawer() {
            setOpenDrawer(!openDrawer);
    }

    return (
        <Sheet variant='soft'>
            <Box paddingX={{xs: 2, md: 6}} display={{xs: 'block', md: 'block'}}>

                <NavBar onChangeStateDrawer={() => handlerDrawer} onChangeTheme = {onChangeTheme}/>

                <DrawerContext.Provider
                    value={{
                        isOpen: openDrawer,
                        handlerClose: () => setOpenDrawer(false),
                        handlerOpen: () => setOpenDrawer(true),
                    }}
                >
                    <Box display={{xs: 'block', sm: 'none'}}>
                        <MyDrawer summary = {summary}/>
                    </Box>
                </DrawerContext.Provider>
            </Box>
        </Sheet>
    );
}

export default AppBar;